'use client'
import { createContext, useCallback, useContext, useMemo, useState } from 'react'

const FeatureFlagContext = createContext({})

const FeatureFlagProvider = ({ children, featurePathOverrides, featureToggleObject }) => {
  const [featureFlags, setFeatureFlags] = useState(featureToggleObject)

  const updateFeatureFlags = useCallback((newFlags) => {
    setFeatureFlags((prev) => ({ ...prev, ...newFlags }))
  }, [])
  const contextValue = useMemo(
    () => ({
      featureFlags,
      featurePathOverrides,
      setFeatureFlags: updateFeatureFlags,
    }),
    [featureFlags, featurePathOverrides, updateFeatureFlags]
  )
  return <FeatureFlagContext.Provider value={contextValue}>{children}</FeatureFlagContext.Provider>
}
const useFeatureFlags = () => useContext(FeatureFlagContext)

export { FeatureFlagProvider, FeatureFlagContext, useFeatureFlags }
